import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AttendanceGroup  {
    _originalTypeClassName = "zERP.BO.AttendanceGroup";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AttendanceGroup.translate = translateService;
}
this.Contracts = [];
this.Id = null;
this.Name = null;
this.ArrivalToleranceMinutes = null;
this.DepartureToleranceMinutes = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
ArrivalToleranceMinutes:any;
DepartureToleranceMinutes:any;
Contracts:any;
static setContracts = ($this, items) => {
                if (items == null) items = [];
                if ($this.Contracts == null) $this.Contracts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Contracts.length > 0) {
                    Domain.AttendanceGroup.removeContracts($this, $this.Contracts[0]);
                }

                Domain.AttendanceGroup.addManyContracts($this, copyItems);
            }
static addManyContracts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AttendanceGroup.addContracts($this, items[i]);
                }
            }
static addContracts = ($this, item) => {
                if ($this.Contracts == null) $this.Contracts = [];
                if (item == null || $this.Contracts.indexOf(item) > -1) return;
                $this.Contracts.push(item);
}
static addRangeContracts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AttendanceGroup.addContracts($this, item));
            }
static removeContracts = ($this, item) => {
                if ($this == null || $this.Contracts == null || $this.Contracts.indexOf(item) === -1) return;
                var _index = $this.Contracts.indexOf(item);
                $this.Contracts.splice(_index, 1);
}
static clearContracts = ($this) => { $this.Contracts = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}